import { Grid } from '@mui/material';
import { PrimaryButton } from '../../theme/index'
import '../../sass/styles.scss';
import { UseScreen } from '../../hooks/UseScreen.hook';
import { useDispatch, useSelector } from 'react-redux';
import { modalDeleteAction } from '../../redux/reducers/Modal';
import { deleteClientAction } from '../../redux/reducers/Delete';

const Client = () => {

  const screenWidth = UseScreen();
  const dispatch = useDispatch();

  const deleteClient = () => {
    dispatch(deleteClientAction()); // delete from db.
    dispatch(modalDeleteAction());
  }

  return (
    <>
        <Grid item xs={ 10 }>
          {
            ( screenWidth > 500 ) ?
              <h5 style={{ margin: '0', marginBottom: '2rem' }}>Cliente / eliminar</h5>
            :
              <h6 style={{ margin: '0', marginBottom: '2rem' }}>Cliente / eliminar</h6>
          }
        </Grid>
        <Grid item xs={ 12 } textAlign='center'>
          {
            ( screenWidth > 500 ) ?
              <h3>Esta seguro que desea eliminar este cliente?</h3>
            :
              <h6>Esta seguro que desea eliminar este cliente?</h6>
          }
        </Grid>
        <Grid item xs={ 12 } sx={{ mt: 2 }} textAlign='center' className='pr-2'>
            <PrimaryButton onClick={ () => dispatch(deleteClient()) } sx={{ width: '50%', boxShadow: 5 }}>Eliminar</PrimaryButton>
        </Grid>
    </>
  )
}

export default Client